export default __webpack_public_path__ + "static/media/logo_trans.fbe2273e.png";